// import { init as initDeliverySlots } from "./components/deliveryScheduleUtil";
import { shippingNewAddressEvents, submitAddressRequest } from "./shippingNewAddress";
import { shippingNewStoreEvents } from "./shippingNewStore";
import { confirmAreaSelect } from "./shippingCoverageArea";
import {
    updateCoverageArea,
    checkCoverageArea,
    getPreviousCheckedAddressStore,
    showCoverageAreaErrorModal,
    isNewAddressInputSelected,
    openNewAddressModal,
    updateShipmentAddress,
    enableNextSlideValidation
} from "./shippingCTUtils";
import { realResizeEvent, handlePostalCodeInputRules, appendPostalOnFocus, waitForEl } from "../utilities/globalUtilities";
import { inputAnimationEvents, initInputOverlayButtons } from "../components/formElementsUtil";
import { initTooltip } from "../components/toolTip";
import { disableStep } from "../checkout/stepsCT";
import { reInitVisualSteps } from "./visualSteps";
import { initDeliverySchedule } from "./components/deliveryScheduleUtil";
import { appendToUrl } from "../search/urlUtils";
import { siblings } from "../utilities/selectorHelper";
import store from "@continente/vue/components/store";
import { checkoutStepShipments } from "../utilities/carouselSlickConfig";
import { updateShippingPaginationBasedOnIndex, selectShippingScheduleBasedOnIndex } from "../checkout/checkoutUtil";
import { isLastShippingSchedule } from "./checkoutUtil";
import { loadingDotsActivation } from "../components/pageLoading";
import { pushShipmentInfoImpression } from "../dataLayer/checkoutShipmentInfo";

const debounce = require("lodash/debounce");

const $cache = {
    document: $(document),
    window: $(window),
    body: $("body"),
    shippingCoverageModal: $("#shipping-coverage-area-modal"),
    shippingNewAddresModal: $("#shipping-new-address-modal"),
    shippingNewStoreModal: $("#shipping-new-store-modal"),
    shippingConfirmCoverageModal: $("#shipping-confirm-coverage-area-modal")
};
let windowWidth = $cache.window.width();

/**
 * @function
 * @description - Shipping common events
 */
const shippingEvents = () => {
    document.querySelectorAll(".step-type--address .pwc-form-check-input").forEach(radioInput => {
        shippingEventsRadioButtonChangeEvent(radioInput);
    });
};

/**
 * @function
 * @description - Handle actions when address input was changed
 * @param {jQuery} $element - jQuery object representing the radio input element
 */
const handleAddressInputChange = ($element) => {
    let activeStep = $element.closest(".step-type--address");
    let targetParams = getAddressStoreData(activeStep);
    let isPrimaryShipment = activeStep.attr("data-is-primary") == "true";

    if (isNewAddressInputSelected($element)) {
        openNewAddressModal($element);
        return;
    }

    let callbackResult;
    checkCoverageArea(targetParams, result => {
        callbackResult = result;
    });

    if (callbackResult.error || !callbackResult.data.storeId) {
        showCoverageAreaErrorModal();
        return;
    }

    targetParams.customerStatus = callbackResult.data.customerStatus;

    if (!isPrimaryShipment) {
        updateShipmentAddress(targetParams, activeStep);
    } else {
        // Show Confirm modal and set where it was triggered from
        $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by", "address-store");
        $("#shipping-address-modal").modal("hide");
        $cache.shippingConfirmCoverageModal.modal("show");
    }
};

/**
 * @function
 * @description - Radio button click event
 * @param {Object} - radioInput - JS selector
 */
const shippingEventsRadioButtonChangeEvent = radioInput => {
    $(radioInput).on("click", e => {
        // let instead of const used here, required for multiple shipment logic
        const $this = $(e.currentTarget);
        const isModalClick = $("#shipping-address-modal").attr("aria-modal") === "true";

        if (!isModalClick) {
            handleAddressInputChange($this);
        } else {
            const idInput = $this.attr("id");
            const inputElement = document.querySelector(`.insert-address input#${idInput}`);
            if (inputElement) {
                inputElement.checked = true;
            }
        }
    });
};

/**
 * Get previously selected store
 * @returns - Previously selected store element
 */
const getPreviouslySelectedStore = () => {
    const activeStepWrapper = document.querySelector(".step-type--address.js-step-active");
    let previousCheckedStoreAddress;

    if (activeStepWrapper) {
        const deliveryAddressID = activeStepWrapper.dataset?.selectedDelivery;
        const shipmentIndex = activeStepWrapper.dataset?.shipmentIndex;
        const overridePreviousAddressSelection = activeStepWrapper.dataset.overridePreviousAddressSelection;

        if (deliveryAddressID && !overridePreviousAddressSelection) {
            previousCheckedStoreAddress = document.querySelector(`input[id*='${shipmentIndex}-${deliveryAddressID}']`);
        }
    }

    return previousCheckedStoreAddress;
};

/**
 * @function
 * @description - Coverage Area confirmation modal events
 * Decline - check the previous delivery method
 * Confirm - change Coverage Area and redirect to Cart page
 */
const coverageAreaConfirmationEvents = () => {
    // Confirmation modal - Decline
    $cache.shippingConfirmCoverageModal.on("click", ".js-decline-coverage-select", () => {
        const source = $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by");

        // Confirmation modal - open from New Address form action
        if (source == "new-address") {
            if (window.mqRespond.status.mobile) {
                $cache.shippingCoverageModal.modal("show");
            } else {
                const addressFormWrapper = document.querySelector("form.ct-adress-form-wrapper");
                const addressInputs = addressFormWrapper.querySelectorAll("input");
                const activeStep = document.querySelector(".js-step-active");
                const selectedRadio = activeStep.querySelector(".pwc-form-check-input:checked");

                addressFormWrapper.reset();
                addressInputs.forEach(input => {
                    input.classList.toggle("filled", input.value !== "");
                });

                if (!isNewAddressInputSelected($(selectedRadio))) {
                    disableStep(activeStep, true);
                    activeStep.classList.add("js-step-active");
                    reInitVisualSteps();
                }
            }
        }

        // Confirmation modal - open from New Store input action
        if (source == "new-store") {
            $cache.shippingNewStoreModal.modal("show");
        }

        if (source == "address-store") {
            let previousCheckedStoreAddress = getPreviouslySelectedStore();

            if (previousCheckedStoreAddress) {
                previousCheckedStoreAddress.checked = true;
            } else {
                $(".js-step-active").find(".pwc-form-check-input").prop("checked", false);
            }
        }

        if (source == "") {
            $cache.shippingCoverageModal.modal("show");
        }
    });

    // Confirmation modal - Accept
    $cache.shippingConfirmCoverageModal.on("click", ".js-confirm-coverage-select", () => {
        const source = $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by");

        $.spinner().start();
        // New Address
        if (source == "new-address") {
            submitAddressRequest();
        }

        // New Store
        if (source == "new-store") {
            const targetParams = getNewStoreData();
            // update Coverage Area
            updateCoverageArea(targetParams);
        }

        // Address or Store on tablet/desktop
        if (source == "address-store") {
            const $activeStep = $(".js-step-active");
            const targetParams = getAddressStoreData($activeStep);
            // update Coverage Area
            updateCoverageArea(targetParams);
        }

        // Address or Store on mobile
        if (source == "") {
            confirmAreaSelect();
        }
    });
};

/**
 * @function
 * @description - returns data necessary for BD call in updateCoverageArea() for new store
 */
const getNewStoreData = () => {
    const $targetElement = $cache.shippingNewStoreModal.find(".pwc-form-check-input:checked").first();
    const selectedPostal = $targetElement.closest(".js-store-details").data("postal");
    const selectedDeliveryLocation = $targetElement.closest(".js-store-details").data("delivery-location");
    const selectedDeliveryLatitude = $targetElement.closest(".js-store-details").data("delivery-latitude");
    const selectedDeliveryLongitude = $targetElement.closest(".js-store-details").data("delivery-longitude");
    const selectedID = $targetElement.closest(".js-store-details").data("sid");

    const targetParams = {
        selectedPostal: selectedPostal,
        selectedDeliveryLocation: selectedDeliveryLocation,
        selectedDeliveryLatitude: selectedDeliveryLatitude,
        selectedDeliveryLongitude: selectedDeliveryLongitude,
        selectedStoreId: selectedID
    };

    return targetParams;
};

/**
 * @function
 * @description - returns data necessary for BD call in updateCoverageArea() for address select
 */
const getAddressStoreData = ($activeStep) => {
    const isCoverageModal = $activeStep.hasClass("coverage-modal-body");
    const $targetElement = $activeStep.find(".pwc-form-check-input:checked").first();
    if (!$targetElement.length) { return; }

    const $selectedRadioInput = isCoverageModal ? $targetElement.closest(".js-store-details") : $targetElement.closest(".pwc-form-radio");
    const selectedPostal = $selectedRadioInput.data("postal");
    const selectedDeliveryLocation = $selectedRadioInput.data("delivery-location");
    const selectedDeliveryLatitude = $selectedRadioInput.data("delivery-latitude");
    const selectedDeliveryLongitude = $selectedRadioInput.data("delivery-longitude");
    const selectedStoreId = $selectedRadioInput.data("store-id") || $selectedRadioInput.data("sid");
    const selectedAddressId = $selectedRadioInput.data("address-id");

    const targetParams = {
        selectedPostal: selectedPostal,
        selectedDeliveryLocation: selectedDeliveryLocation,
        selectedDeliveryLatitude: selectedDeliveryLatitude,
        selectedDeliveryLongitude: selectedDeliveryLongitude,
        selectedStoreId: selectedStoreId,
        selectedAddressId: selectedAddressId
    };

    return targetParams;
};

/**
 * @function
 * @description - Gets the postal code of the selected home address and returns nearest stores
 * @param {Object} - addressSelected - JQuery selector
 */
const loadStores = addressSelected => {
    const selectedAddress = addressSelected || $(".js-shipping-hd-addresses input:checked");
    const shipments = $(".shipping-step--wrapper");
    let google = window.google;
    let geocoder = new google.maps.Geocoder();

    shipments.each((index, shipment) => {
        const $shipment = $(shipment);
        const address = $shipment.find(selectedAddress);
        const $storesContainer = $shipment.find(".js-stores-container-shipment");
        const $addressWrapper = $shipment.find(".step-type--address");
        const currentShipmentStore = $addressWrapper.attr("data-current-shipment-store");
        const clickAndGoStoreId = $addressWrapper.attr("data-click-and-go-store-id");
        const currentSelectedAddressPostal =
            $(address).closest(".js-type-address").attr("data-postal") ||
            $addressWrapper.attr("data-current-shipment-store-postal-code") ||
            $addressWrapper.attr("data-shipping-postal-code");

        $storesContainer.spinner().start();

        if (clickAndGoStoreId && clickAndGoStoreId !== "undefined" && clickAndGoStoreId !== "null") {
            const params = {
                clickAndGoStoreId,
                currentShipmentStore: currentShipmentStore
            };

            const url = $storesContainer.attr("data-url");
            renderShippingStores($storesContainer, $shipment, url, params);
        } else {
            geocoder.geocode({"address": currentSelectedAddressPostal, "componentRestrictions": {"country": "PT"}}, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0].geometry.location.lat() && results[0].geometry.location.lng()) {
                        let deliveryPostalCode = "";
                        let result = results[0];
                        for (let i = 0; i < result.address_components.length; i++) {
                            let addressComponent = result.address_components[i];

                            if (addressComponent.types.indexOf("postal_code") !== -1 && addressComponent.long_name) {
                                deliveryPostalCode = addressComponent.long_name;
                                break;
                            }
                        }

                        const params = {
                            deliveryLocation: currentSelectedAddressPostal,
                            deliveryPostalCode: deliveryPostalCode,
                            latitude: results[0].geometry.location.lat(),
                            longitude: results[0].geometry.location.lng(),
                            searchLatitude: results[0].geometry.location.lat(),
                            searchLongitude: results[0].geometry.location.lng(),
                            currentShipmentStore: currentShipmentStore
                        };

                        const url = $storesContainer.attr("data-url");
                        renderShippingStores($storesContainer, $shipment, url, params);
                    }
                } else {
                    $shipment.find(".ct-nearest-stores-list").html("");
                    $storesContainer.spinner().stop();
                }
            });
        }
    });
};

/**
 * @function
 * @description - Function to return and populate shipping stores based on the new selected postal code
 * @param {Object} - $storesContainer - JQuery selector
 * @param {Object} - $shipment - JQuery selector
 * @param {String} - url - URL string
 * @param {Object} - params - Parameters for the ajax call
 */
const renderShippingStores = ($storesContainer, $shipment, url, params = {}) => {
    if (!url) return Promise.resolve();

    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            type: "GET",
            data: params,
            success: response => {
                if (response) {
                    $storesContainer.html(response);

                    const $currentShipmentDataContainer = $shipment.find(".step-type--address");

                    if ($currentShipmentDataContainer && $currentShipmentDataContainer.length) {
                        const selectedStore = $currentShipmentDataContainer.attr("data-selected-delivery");
                        const shipmentNumber = $currentShipmentDataContainer.attr("data-shipment-index");

                        if (selectedStore) {
                            $storesContainer.find(`input[id="shipment-${shipmentNumber}-${selectedStore}"]`).prop("checked", true);
                        }
                    }

                    $storesContainer.get(0).querySelectorAll(".pwc-form-check-input").forEach(radioInput =>  {
                        shippingEventsRadioButtonChangeEvent(radioInput);
                    });
                }

                resolve();
            },
            complete: () => {
                $storesContainer.spinner().stop();
                $storesContainer.addClass("render-shipping-stores-complete-js");
                reject();
            }
        });
    });
};

/**
 * @function
 * @description -  Sets up an event handler for the CTA click on elements with the class `.js-select-new-address` within the `#shipping-address-modal`.
 * When triggered, the chosen address from the cloned input in the modal is passed to the real address input in the step-body-selection.
 */
const setupSelectNewAddressEvent = () => {
    $(document).on("click", ".js-select-new-address", function () {
        const checkedInput = $(".insert-address input:checked");
        if (checkedInput.length > 0) {
            const idInput = checkedInput.attr("id");
            const input = document.getElementById(idInput);
            input.checked = true;
            handleAddressInputChange($(input));
        }
    });
};

/**
 * @function
 * @description - Loads the available shipments for the shipment ID from its original location (step-body-selection)
 * and clones them into the new modal to select a HOME address.
 */
const loadAddressesModal = () => {
    $(document).on("click", ".js-action-change-address", function () {
        let stepBodySelectionClone = $(this).closest(".step-type--address")?.find(".js-step-body-selection")?.clone();

        if (stepBodySelectionClone) {
            stepBodySelectionClone.find(".js-stores-container-shipment")?.remove();
            stepBodySelectionClone.find(".js-shipping-hd-addresses")?.removeClass("d-none");
            stepBodySelectionClone.removeClass("d-none");

            $(".insert-address").empty().append(stepBodySelectionClone);
        }
    });
};

/**
 * @function
 * @description - Add content for tablet/desktop Shipping store modal
 */
const loadNewStoreModal = () => {
    const $newStoreBtn = $(".js-action-new-store");
    const $modalBody = $(".shipping-new-store-modal--body");
    const shipmentWrapper = $newStoreBtn.closest(".js-step-body-inner");
    const selectedAddress = shipmentWrapper.find(".js-type-address .pwc-form-check-input:checked");
    let url = $newStoreBtn.data("url");

    if (selectedAddress.length) {
        const params = {
            "postalCode": selectedAddress.parent(".js-type-address").data("postal")
        };

        url = appendToUrl(url, params);
    }

    $.ajax({
        url: url,
        type: "GET",
        success: response => {
            $modalBody.replaceWith(response);

            initTooltip(("#shipping-new-store-modal"));
            initInputOverlayButtons("#coverage-postal-code");
            inputAnimationEvents();
            $cache.document.trigger("initFormValidation");

            // reinit events
            shippingNewStoreEvents();
            $.applyDataMask($("#shipping-new-store-modal").find("[data-mask]"));
            handlePostalCodeInputRules();
            appendPostalOnFocus($("#coverage-postal-code"));

            let previousCheckedStoreAddress;
            getPreviousCheckedAddressStore(prevCheckedAddress => {
                previousCheckedStoreAddress = prevCheckedAddress;
            });

            const postalCodeInput = document.getElementById("coverage-postal-code");

            if (postalCodeInput.value != "") {
                const [confirmPostalCodeBtn] = siblings(postalCodeInput, ".submit-postal-code");

                confirmPostalCodeBtn.click();
            }

            const $deliveryNearest = $cache.shippingNewStoreModal.find(".delivery-nearest");
            //set store if it was selected from address/store before the map was initialized
            if (previousCheckedStoreAddress && previousCheckedStoreAddress.length) {
                let previousCheckedStoreAddressId = previousCheckedStoreAddress.attr("id");
                if (previousCheckedStoreAddressId) {
                    let selectedStoreMapRadio = $deliveryNearest.find(`#store-${previousCheckedStoreAddressId}`);
                    if (selectedStoreMapRadio && selectedStoreMapRadio.length) {
                        selectedStoreMapRadio.find(".pwc-form-check-input").prop("checked", true);
                    } else {
                        $deliveryNearest.find(".pwc-form-check-input").prop("checked", false);
                    }

                }
            } else {
                /*
                    in case when no address or store was not selected and customer selects the store from store map,
                    the store saved in shipment will be shown selected
                */
                const currentShipmentSelectedStore = $("[data-current-shipment-store]").data("current-shipment-store");
                if (currentShipmentSelectedStore) {
                    let selectedStoreMapRadio = $deliveryNearest.find(`#store-${currentShipmentSelectedStore}`);
                    selectedStoreMapRadio.find(".pwc-form-check-input").prop("checked", true);
                }
            }
        }
    });
};

/**
 * @function
 * @description - Shipping step modals events
 */
const shippingModalsEvents = () => {
    $cache.body.on("hidden.bs.modal", "#shipping-confirm-coverage-area-modal", e => {
        if (e.currentTarget.dataset.pageReload ==  "true") { return; }
        const source = $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by");

        // Confirmation modal - open from main page action
        if (source == "address-store" && !window.mqRespond.status.mobile) {
            const activeStep = document.querySelector(".js-step-active");
            const selectedDeliveryID = activeStep.getAttribute("data-selected-delivery");
            const selectedDeliveryShipmentIndex = activeStep.getAttribute("data-shipment-index");
            const selectedDeliveryIDSelector = `#shipment-${selectedDeliveryShipmentIndex}-${selectedDeliveryID}`;
            if (selectedDeliveryID == "") { return; }
            if (!activeStep.querySelector(selectedDeliveryIDSelector)) { return; }
            activeStep.querySelector(selectedDeliveryIDSelector).checked = true;
        }

        if (source == "address-store") {
            let previousCheckedStoreAddress = getPreviouslySelectedStore();

            if (previousCheckedStoreAddress) {
                previousCheckedStoreAddress.checked = true;
            } else {
                $(".js-step-active").find(".pwc-form-check-input").prop("checked", false);
            }
        }

        // Confirmation modal - Reset triggered from
        $cache.shippingConfirmCoverageModal.find(".modal-body").data("triggered-by", "");
    });
};

/**
 * @function
 * @description - Shipping step updates on resize
 */
const handleShippingOnResize = () => {
    if (window.mqRespond.status.mobile) {
        if ($cache.shippingNewAddresModal.is(":visible")) {
            $cache.shippingNewAddresModal.modal("hide");
        }

        if ($cache.shippingNewStoreModal.is(":visible")) {
            $cache.shippingNewStoreModal.modal("hide");
        }
    } else {
        if ($cache.shippingCoverageModal.is(":visible")) {
            $cache.shippingCoverageModal.modal("hide");
        }
    }
};

/**
 * @function
 * @description - Resize event handler
 */
const shippingResizeEvent = () => {
    window.addEventListener("resize", debounce(() => {
        if (!realResizeEvent(windowWidth)) { return; }
        windowWidth = $cache.window.width();

        handleShippingOnResize();
    }, 200));
};

/**
 * @function
 * @description - Retry to load delivery slots again
 */
const retryDeliverySlots = () => {
    $cache.body.on("click", ".js-retry-delivery-slots", () => {
        initDeliverySchedule();
    });
};

/**
 * @function
 * @description - Retry to submit order if the order fails
 */
const retryOrderSubmit = () => {
    $cache.body.on("click", ".js-retry-submit-order", () => {
        const $placeOrder = $(".js-place-order");

        if ($placeOrder && $placeOrder.length) {
            $(".js-place-order").trigger("click");
        }
    });
};

/**
 *  * @function
 * Handles the Shipping Methods Selection
 */
const handleShippingSelection = () => {
    $(".checkout-continue button").off("click").on("click", (e) => {
        const $this = $(e.currentTarget);
        const shipmentInformation = store.getters.getShipmentInformation();
        const $shipmentsContainer = $(".js-shipment-steps-container");
        const url = $this.data("checkout-payment-url");
        const shipmentDeliverySlots = document.querySelectorAll(".shipping-delivery-slot");
        const isEntregaZero = $shipmentsContainer[0]?.querySelector(".js-delivery-slot-entrega-zero");
        if ($shipmentsContainer.hasClass("slick-initialized")) {
            const currentSlideIndex = $shipmentsContainer.slick("slickCurrentSlide");
            const currentShippingStepID = shipmentDeliverySlots[currentSlideIndex]?.getAttribute("data-shipment-id");
            const shipmentFromStoreGetters = shipmentInformation.find(shipment => shipment.shipmentID === currentShippingStepID);
            const isSlotSelected = shipmentFromStoreGetters && shipmentFromStoreGetters?.chosenPrice != "-" || isEntregaZero;
            const isLastSlide = isLastShippingSchedule($shipmentsContainer);
            const isNonSchedule = shipmentDeliverySlots[currentSlideIndex].querySelector(".delivery-schedule-date")?.classList.contains("non-scheduled-delivery");
            const currentSlideShipmentContainer = isNonSchedule ? shipmentDeliverySlots[currentSlideIndex]?.querySelectorAll(".delivery-schedule-date-item.is-non-schedule.selected-non-scheduled") : shipmentDeliverySlots[currentSlideIndex]?.querySelectorAll(".interval-item-wrapper.selected");

            if (isSlotSelected && !isLastSlide) {
                $shipmentsContainer.slick("slickNext");
                return;
            } else if (!isSlotSelected || currentSlideShipmentContainer.length == 0) {
                const $checkoutNoDeliveryModal = $("#checkout-no-delivery-modal");
                $checkoutNoDeliveryModal.modal("show");
                return;
            }
        } else {
            const shipmentNotSelected = shipmentInformation.length ? shipmentInformation.filter(elem => elem.chosenPrice == "-") : false;
            if (!isEntregaZero && !shipmentNotSelected || shipmentNotSelected.length > 0) {
                const $checkoutNoDeliveryModal = $("#checkout-no-delivery-modal");
                $checkoutNoDeliveryModal.modal("show");
                return;
            }
        }

        if (url) {
            loadingDotsActivation(".submit-shipping");
            pushShipmentInfoImpression();
            window.onbeforeunload = null;
            window.location.href = url;
        }

    });
};

/**
 * Initializes the shipments carousel
 */
const initShipmentsCarousel = () => {
    const $shipmentsContainer = $(".js-shipment-steps-container");
    const shippingsCount = $(".js-shipment-step")?.length;

    if (shippingsCount >= 2) {
        $shipmentsContainer
            .on("init", (e, slick) => {
                const element = e.currentTarget;
                waitForEl(".render-shipping-stores-complete-js", function () {
                    updateShippingPaginationBasedOnIndex(slick);
                    const firstShipmentContainer = element?.querySelector(".js-shipment-step");
                    selectShippingScheduleBasedOnIndex(firstShipmentContainer);
                    enableNextSlideValidation();
                });
            })
            .slick(checkoutStepShipments)
            .on("afterChange", (e, slick) => {
                updateShippingPaginationBasedOnIndex(slick);
                const element = e.currentTarget;
                const currentSlide = slick?.currentSlide;
                if (element && currentSlide) {
                    const shipmentsContainer = element.querySelector(`.js-shipment-step[data-slick-index="${currentSlide}"]`);
                    selectShippingScheduleBasedOnIndex(shipmentsContainer);
                }
                enableNextSlideValidation();
            });

        const slider = document.querySelector(".slick-slider");
        const resizeObserver = new ResizeObserver(() => {
            $(slider).slick("setPosition");
        });

        slider.querySelectorAll(".slick-slide").forEach(slide => resizeObserver.observe(slide));

        const shipmentPrevArrow = document.querySelector(".shipment-prev-arrow");
        const shipmentNextArrow = document.querySelector(".shipment-next-arrow");
        const shipmentCarouselArrows = document.querySelector(".js-checkout-shippment-arrows");

        shipmentPrevArrow.setAttribute("title", shipmentCarouselArrows.dataset.backTooltip);
        shipmentNextArrow.setAttribute("title", shipmentCarouselArrows.dataset.advanceTooltip);

        initTooltip(".js-checkout-shippment-arrows");
    } else {
        window.addEventListener("load", () => {
            selectShippingScheduleBasedOnIndex();
        });
    }
};

/**
 * @function
 * @description - Init Shipping events
 */
const initShippingEvents = () => {
    shippingEvents();
    coverageAreaConfirmationEvents();
    shippingNewAddressEvents();
    shippingModalsEvents();
    shippingResizeEvent();
    retryDeliverySlots();
    loadAddressesModal();
    setupSelectNewAddressEvent();

    $(window).on("load", () => {
        loadStores();
    });
};

export { initShippingEvents, getNewStoreData, loadNewStoreModal, shippingEventsRadioButtonChangeEvent, retryOrderSubmit, loadStores, getAddressStoreData, renderShippingStores, handleShippingSelection, initShipmentsCarousel };
